<template>
  <loader-wrapper :loading="loading || loadingResp" style="position: relative">
    <section v-if="!isDriver" class="ymap-select-status">
      <el-select v-model="status" placeholder="Select">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.label"
          :value="item.id"
        />
      </el-select>
    </section>
    <yandex-map
      :settings="settings"
      :coords="center"
      :zoom="zoom"
      :controls="controls"
      :cluster-options="clusterOptions"
      ymap-class="ymap-mobile"
      @map-was-initialized="mapLoaded"
    >
      <ymap-marker
        v-for="car in filtredCars"
        :key="car.id"
        :marker-id="car.id"
        :coords="car.coords"
        :icon="getContentLayout(car)"
        cluster-name="cluster"
      />
    </yandex-map>
  </loader-wrapper>
</template>

<script>
import {
  MAP_CENTER,
  balloonLayout,
  clusterOptions,
  colors,
  markerIcon,
  multiRouteOptions,
  options,
  ymapSettings,
} from './constants'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { defaultDate } from '@/datas/DateFormats'
import { getNow } from '@/helpers/date'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const RespAPI = RepositoryFactory.get('responses')

export default {
  name: 'YMap',
  components: { LoaderWrapper },
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    driver: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      center: MAP_CENTER,
      zoom: 8,
      controls: ['zoomControl', 'fullscreenControl'],
      points: [],
      cars: [],
      settings: ymapSettings,
      markerIcon,
      clusterOptions,
      loading: true,
      loadingResp: false,
      map: null,
      status: -1,
      colors,
      options,
    }
  },
  computed: {
    isDriver() {
      return this.isDriverRole || this.driver
    },
    filtredCars() {
      return this.status > -1
        ? this.cars.filter(c => c.status === this.status)
        : this.cars
    },
  },
  watch: {
    bid() {
      if (this.map) {
        this.map.geoObjects.removeAll()
      }
      this.setCenter()
    },
  },
  methods: {
    getContentLayout(car) {
      const contentLayout =
        `<div class="ym-marker-style ${this.colors[car.status]}">${
          car.num
        }</div>` +
        `<i class="el-icon-truck ym-icon-style ${this.colors[car.status]}" />`

      return { ...this.markerIcon, contentLayout }
    },
    mapLoaded(e) {
      e.options.set('suppressMapOpenBlock', true)
      this.map = e
      this.setCenter()
    },
    setCenter() {
      this.loading = true
      const {
        load_coords_lat,
        load_coords_lon,
        unload_coords_lat,
        unload_coords_lon,
        load_days,
      } = this.bid

      if (!this.isDriver) {
        const today = load_days.find(d => d.load_date === getNow(defaultDate))

        if (today && today.id) {
          this.getCoords(today.id)
        }
      }
      if (load_coords_lat && unload_coords_lat && window.ymaps && this.map) {
        this.points = [
          [load_coords_lat, load_coords_lon],
          [unload_coords_lat, unload_coords_lon],
        ]
        const balloon = window.ymaps.templateLayoutFactory.createClass(
          ...balloonLayout,
        )
        const opt = multiRouteOptions(this.points, balloon)
        const multiRoute = new window.ymaps.multiRouter.MultiRoute(...opt)

        this.map.geoObjects.add(multiRoute)
        multiRoute.events.once('update', this.stopLoading)
      } else {
        this.stopLoading()
      }
    },
    getCoords(load_day_id) {
      this.loadingResp = true
      RespAPI.getCoords({ load_day_id })
        .then(({ data }) => this.getCars(data))
        .catch(err => this.errHandler(err))
        .finally(() => (this.loadingResp = false))
    },
    getCars(data) {
      if (data && data.items) {
        const arr = []

        data.items.map(b => {
          const { id, coords, automobile_state_numbers: num, status } = b

          if (coords && coords.lat && coords.lng) {
            arr.push({ id, num, coords: [coords.lat, coords.lng], status })
          }
        })
        this.cars = arr
      }
    },
    stopLoading() {
      this.loading = false
    },
  },
}
</script>

<style lang="sass">
.ymap-select-status
  position: absolute
  z-index: 1001
  .el-select
    width: auto
.ym-marker-style
  font-weight: bold
  white-space: nowrap
  font-size: 12px
.ym-red
  color: #ff0000
.ym-yellow
  color: #E6A23C
.ym-green
  color: #67C23A
.ym-icon-style
  width: 65px
  font-size: 35px
  margin-top: -5px
.ymap-mobile
  height: 70vh
.my-balloon-zerno
  display: inline-block
  padding: 4px 10px
  height: 75px
  width: 158px
  font-size: 11px
  line-height: 15px
  color: #333333
  text-align: left
  vertical-align: middle
  background-color: #FFFFF6
  border: 1px solid #CDB7B5
  border-radius: 6px
  font-family: Arial
  .close-balloon-zerno
    margin-top: -3px
    float: right
    font-size: 20px
    font-weight: bold
    line-height: 20px
    color: #000
    text-shadow: 0 1px 0 #fff
    opacity: .2
</style>
